import { memo, useCallback } from 'react';
import PlayerMenuTooltip from '@/App/remotion/components/PlayerMenus/PlayerMenuTooltip';
import { SelectionOutlineAction } from '@/App/remotion/components/Outlines/types';
import EventBus from '@/libs/eventBus/eventBus';
import { CustomEvents } from '@/libs/eventBus/constants';
import { deleteElementHandler } from '@/Pages/Clip/ClipPlayer/ClipAssets/handlers';
import { useClipsContext } from '@/context/ClipsContext/ClipsContext';
import Icon from '@/components/atoms/Icon';

function LottieElementRemoveButton({ lottieElementId }: { lottieElementId: string }) {
  const { clipData, clipId } = useClipsContext();

  const removeLottieElement = useCallback(() => {
    deleteElementHandler(clipData, clipId, lottieElementId);
    EventBus.dispatch(CustomEvents.SelectionOutlineAction, {
      action: SelectionOutlineAction.DESELECT
    });
  }, [clipData, clipId, lottieElementId]);

  return (
    <button
      onClick={removeLottieElement}
      data-testid="lottie-element-remove-button"
      className="group/button flex size-10 items-center justify-center rounded-md hover:bg-slate-100"
    >
      <Icon name="IconTrash" size={20} />
      <PlayerMenuTooltip content="Remove" />
    </button>
  );
}

export default memo(LottieElementRemoveButton);
